module.exports = __webpack_public_path__ + "static/hovalin-strings-tuners-c41ce20904dcbee2a978fb502851f40b.jpg";